import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { COMPANY, waLink } from '../data/company';
export function CallToAction() {
  return <section className="relative overflow-hidden bg-ink-soft py-24" data-id="element-41" data-mp="14bnbq5f6pvjx">
      <div className="absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/10 blur-[120px]" data-id="element-42" data-mp="149aqnje4r52n" />
      <div className="relative mx-auto max-w-3xl px-5 text-center" data-id="element-43" data-mp="ucpod5thw82i">
        <motion.h2 initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-display text-3xl font-bold leading-tight sm:text-4xl md:text-5xl" data-id="element-44" data-mp="ufk8sxcidsvx">
          Bingung mencari rental mobil <span className="text-gold-gradient" data-id="element-45" data-mp="2fqk8k1hm1p1u">terpercaya di Garut?</span>
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/65 sm:text-base" data-id="element-46" data-mp="2kpn50xjiymy7">
          Hubungi PT Wardah Pratama Transport sekarang juga dan nikmati layanan transportasi yang
          nyaman, aman, dan profesional.
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-9" data-id="element-47" data-mp="2eou0zdmwmruc">
          <a href={waLink(`Halo ${COMPANY.name}, saya ingin memesan rental mobil.`)} target="_blank" rel="noopener noreferrer" className="btn-glow-gold inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-base font-semibold" data-id="element-48" data-mp="1mzh5y825f6ay">
            <MessageCircleIcon className="h-5 w-5" data-id="element-49" data-mp="37cy9s80rvl19" /> Hubungi via WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}